"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinWordsQuickRule = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _QuickRule2 = require("./QuickRule");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MinWordsQuickRule = /*#__PURE__*/function (_QuickRule) {
  _inherits(MinWordsQuickRule, _QuickRule);

  var _super = _createSuper(MinWordsQuickRule);

  function MinWordsQuickRule() {
    _classCallCheck(this, MinWordsQuickRule);

    return _super.apply(this, arguments);
  }

  _createClass(MinWordsQuickRule, [{
    key: "addRule",
    value: function addRule(helper, input) {
      var minWords = input.minWords;
      var wordsVariableName = 'Words';

      var wordsVariableKey = _lodash.default.camelCase(wordsVariableName);

      var wordsCountVariableName = 'Words Count';

      var wordsCountVariableKey = _lodash.default.camelCase(wordsCountVariableName);

      var conditionName = "Min Words ".concat(minWords);

      var conditionKey = _lodash.default.camelCase(conditionName);

      helper.addVariable({
        name: wordsVariableName,
        key: wordsVariableKey,
        valueSource: 'thisComponentValue',
        transform: {
          name: 'split',
          splitArguments: {
            separator: {
              valueSource: 'regExp',
              regExpInput: {
                pattern: '\\s+'
              }
            }
          }
        }
      });
      helper.addVariable({
        name: wordsCountVariableName,
        key: wordsCountVariableKey,
        valueSource: 'variable',
        variableInput: wordsVariableKey,
        transform: {
          name: 'length'
        }
      });
      helper.addCondition({
        name: conditionName,
        key: conditionKey,
        conjunction: 'and',
        parts: [{
          type: 'new',
          operator: {
            name: 'greaterThanOrEqual',
            greaterThanOrEqualArguments: {
              left: {
                valueSource: 'variable',
                variableInput: wordsCountVariableKey
              },
              right: {
                valueSource: 'number',
                numberInput: minWords
              }
            }
          }
        }]
      });
      var validation = {
        condition: conditionKey,
        group: 'minWords',
        severity: 'error',
        message: "Min words count exceeded (".concat(minWords, ")")
      };
      helper.addValidation(validation);
      helper.execute();
      return validation;
    }
  }], [{
    key: "getEditForm",
    value: function getEditForm() {
      return [{
        label: 'Min Words',
        key: 'minWords',
        type: 'number',
        input: true,
        validate: {
          required: true
        }
      }];
    }
  }, {
    key: "name",
    get: function get() {
      return 'minWords';
    }
  }, {
    key: "title",
    get: function get() {
      return 'Min Words';
    }
  }, {
    key: "weight",
    get: function get() {
      return 300;
    }
  }]);

  return MinWordsQuickRule;
}(_QuickRule2.QuickRule);

exports.MinWordsQuickRule = MinWordsQuickRule;